import styled from 'styled-components';

export const HeaderCardStyled = styled.h2`
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;

  div {
    display: flex;
    column-gap: 4px;
  }
`;
